
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class SubwebsiteDialog extends Vue {
  @Prop() public suffixDomain: string;

  public visible: boolean = true;

  public subwebsiteDomain: string = '';

  public excludeActions: string[] = ['wp', 'db', 'email'];


  public get message(): string {
    return `Create "${this.suffixDomain}" sub domain`;
  }

  public create(): void {
    if (!/^(?!:\/\/)([a-zA-Z0-9]([a-zA-Z0-9-]{1,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
        .test(`${this.subwebsiteDomain}.${this.suffixDomain}`)) {
      this.$errorDialog.show('Invalid Domain');

      return;
    }

    this.$emit('createSubwebsite', { domain: this.subwebsiteDomain, excludeActions: this.excludeActions });
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  public excludeAction(action: string, value: boolean): void {
    if (value) {
      this.excludeActions = this.excludeActions.filter((a) => a !== action);

      return;
    }

    this.excludeActions.push(action);
  }
}
